import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-body tracking-wide">
            User Reviews
          </span>
          <h2 className="mt-4 text-3xl md:text-5xl font-bold text-foreground-950 font-heading leading-tight">
            Real Shopper<br />
            <span className="italic font-normal text-accent-500">Reviews</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-600 font-body max-w-md">
            See what the community says about using Hipobuy Spreadsheet for product discovery and research.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {[0, 1, 2].map((colIdx) => (
            <div key={colIdx} className="flex flex-col gap-5">
              {testimonials
                .filter((_, i) => i % 3 === colIdx)
                .map((t) => (
                  <div
                    key={t.handle}
                    className="bg-background-50 rounded-2xl p-6 border border-background-200"
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 text-sm font-semibold font-body">
                        {t.avatar}
                      </div>
                      <div className="flex flex-col">
                        <span className="text-sm font-semibold text-foreground-900 font-body">{t.name}</span>
                        <span className="text-xs text-foreground-400 font-body">{t.handle}</span>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 font-body leading-relaxed">
                      &ldquo;{t.text}&rdquo;
                    </p>
                  </div>
                ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}